import * as memoMessageType from './memoMessageType'
import useMemomessageTerminate from './useMemomessageTerminate'

import Grid from '@material-ui/core/Grid'
import { Form, FormSpy } from 'react-final-form'
import arrayMutators from 'final-form-arrays'
import { memorandumTopic } from '../../../../../constants/constants'
import useTranslate from '../../../../../i18n/useTranslate'
import PageAction from '../pageAction'
import Dialog from '../../../../../control/dialog/dialog'
import MyAccordion from '../../../../../control/accordion/accordion'
import RichTextEditor from '../../../../../control/richTextEditor/richTextEditor'
import MyDatePicker from '../../../../../control/datepicker/datepicker'
import UploadDoc from '../../../shareUI/uploadDoc/uploadDoc'
import DisplayUpdater from '../../../shareUI/displayUpdater/displayUpdater'
import { richEditorRequired } from '../../../../../utilities/validate'
import ModeAccordion from '../../../shareUI/modeAccordion/ModeAccordion'
import useAppFolderAndTabStore from '../../../../../stores/appFolderAndTab/appFolderAndTabStore'

//View
const MemoMessageView = (props: memoMessageType.MemomessageViewType) => {
    const {
        formRef,
        isViewMode,
        configDialog,
        initialValues,
        isShowUpdateDate,
        initialMemorandumFile,
        initialCommentCommitee,
        initialMemoMessagePaper,
        onRefDialog,
        onDirtyChange,
        onSubmitForm,
        onClickOpenFile,
        onClickBackToSearch,
        handleSubmitUpdateMemo,
        handleCancle,
        onClickEdit,
    } = props

    const translate = useTranslate()
    const appFolderAndTabStore = useAppFolderAndTabStore()

    const latestFolderIdx = 0
    const currentSelectFolder =
        appFolderAndTabStore.folderList[latestFolderIdx].submittedID === appFolderAndTabStore.folderSelected.submittedID
    const isEdit = isViewMode && currentSelectFolder

    const renderViewComponent = (language: string) => {
        return (
            <Grid container>
                <Grid item xs={12}>
                    <RichTextEditor
                        name={`memoMessagePaper_${language}`}
                        initialRichTextEditor={
                            language === 'TH' ? initialMemoMessagePaper?.TH : initialMemoMessagePaper?.EN
                        }
                        disabled={isViewMode}
                        isHideToolbar={isViewMode}
                    />
                </Grid>
            </Grid>
        )
    }

    const renderEditComponent = (language: string) => {
        return (
            <Grid container>
                <Grid item xs={12}>
                    <RichTextEditor
                        name={`memoMessagePaper_${language}`}
                        initialRichTextEditor={
                            language === 'TH' ? initialMemoMessagePaper?.TH : initialMemoMessagePaper?.EN
                        }
                        required
                        validates={
                            formRef.current?.values[`memoMessagePaper_${language}`]?.contentHtml === '<p></p>\n'
                                ? [richEditorRequired(translate.get('MESSAGE.M015'))]
                                : []
                        }
                    />
                </Grid>
            </Grid>
        )
    }
    return (
        <Form
            onSubmit={onSubmitForm}
            initialValues={{ ...initialValues, memorandumFile: initialMemorandumFile }}
            mutators={{
                ...arrayMutators,
            }}
            keepDirtyOnReinitialize={true}
        >
            {(formProps) => {
                formRef.current = formProps

                return (
                    <>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <MyAccordion title={translate.get('LABEL.MEMO_MESSAGE_DETAIL')}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={12} lg={12}>
                                            <RichTextEditor
                                                name={`commentCommittee`}
                                                initialRichTextEditor={initialCommentCommitee}
                                                disabled={true}
                                                isHideToolbar={isViewMode}
                                                label={translate.get('LABEL.SUGGESTION_NOTICE')}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={12} lg={12}>
                                            <MyDatePicker
                                                name="memoMessageDate"
                                                label={translate.get('LABEL.MEMO_MESSAGE_DATE')}
                                                disabled={isViewMode}
                                                required
                                            />
                                        </Grid>
                                    </Grid>
                                </MyAccordion>
                            </Grid>

                            <Grid item xs={12}>
                                <ModeAccordion
                                    title={translate.get('LABEL.MEMO_MESSAGE_PAPER_TH')}
                                    renderViewComponent={() => renderViewComponent('TH')}
                                    renderEditComponent={() => renderEditComponent('TH')}
                                    isViewMode={isEdit}
                                    fieldNames={['memoMessagePaper_TH']}
                                    onConfirm={() => handleSubmitUpdateMemo(['memoMessagePaper_TH'])}
                                    onCancel={handleCancle}
                                    onClickEdit={onClickEdit}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <ModeAccordion
                                    title={translate.get('LABEL.MEMO_MESSAGE_PAPER_EN')}
                                    renderViewComponent={() => renderViewComponent('EN')}
                                    renderEditComponent={() => renderEditComponent('EN')}
                                    isViewMode={isEdit}
                                    fieldNames={['memoMessagePaper_EN']}
                                    onConfirm={() => handleSubmitUpdateMemo(['memoMessagePaper_EN'])}
                                    onCancel={handleCancle}
                                    onClickEdit={onClickEdit}
                                />
                            </Grid>

                            <Grid item xs={12} md={12} lg={12}>
                                <UploadDoc
                                    name={'memorandumFile'}
                                    initialData={initialMemorandumFile}
                                    documentTitleList={memorandumTopic}
                                    title={translate.get('LABEL.MEMO_MESSAGE_DOC')}
                                    isViewMode={true}
                                    disabledBtn={true}
                                    onClickOpenFile={onClickOpenFile}
                                />
                            </Grid>

                            {isShowUpdateDate && <DisplayUpdater />}

                            {!isViewMode && (
                                <Grid item xs={12} md={12} lg={12}>
                                    <PageAction
                                        onClickSaveDraft={() => {
                                            formProps.form.change('submitType', 'draft')
                                            formProps.handleSubmit()
                                        }}
                                        onClickSave={() => {
                                            formProps.form.change('submitType', 'save')
                                            formProps.handleSubmit()
                                        }}
                                        onClickClose={onClickBackToSearch}
                                    />
                                </Grid>
                            )}
                        </Grid>
                        <FormSpy subscription={{ values: true, dirty: true }} onChange={onDirtyChange} />
                        <Dialog onRef={onRefDialog} {...configDialog} />
                    </>
                )
            }}
        </Form>
    )
}

//Controller
const MemomessageCtrl = (props: memoMessageType.MemomessageCtrlType) => {
    const useMemomessageTerminateModel = useMemomessageTerminate(props)
    return <MemoMessageView {...useMemomessageTerminateModel} {...props} />
}
export default MemomessageCtrl
